import { useEffect, useState } from "react";
import api from "../services/api";

export default function Dispatch() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    loadOrders();
    const timer = setInterval(loadOrders, 8000);
    return () => clearInterval(timer);
  }, []);

  // 🔁 LOAD ORDER + ITEMS
  const loadOrders = async () => {
    try {
      const res = await api.get("/dispatch/orders/details");
      setOrders(res.data || []);
    } catch (err) {
      console.error("Failed to load dispatch orders", err);
    }
  };

  const minutesElapsed = (openedAt) => {
  if (!openedAt) return 0;
  const diffMs = Date.now() - new Date(openedAt).getTime();
  return Math.floor(diffMs / 60000);
};



  const dispatchOrder = (orderId) => {
  // 1️⃣ Remove order instantly
  const removedOrder = orders.find(o => o.live_order_id === orderId);
  setOrders(prev => prev.filter(o => o.live_order_id !== orderId));

  // 2️⃣ Call backend
  api.post(`/dispatch/order/${orderId}`)
    .catch(() => {
      // 3️⃣ Restore if failed
      setOrders(prev => [...prev, removedOrder]);
      alert("Failed to dispatch order");
    });
};


  return (
    <div style={{ padding: 20 }}>
      <h2>Dispatch Screen</h2>

      {orders.length === 0 ? (
        <p>No orders ready for dispatch</p>
      ) : (
        <div style={gridStyle}>
          {orders.map(order => (
            <div key={order.live_order_id} style={cardStyle}>
              {/* HEADER */}
              <div style={headerStyle}>
                <div>
  <strong>Order #{order.order_no}</strong>

  <div style={{ fontSize: 12, color: "#555" }}>
    {order.order_type}
  </div>

  <div style={{ fontSize: 12, color: "#d32f2f", marginTop: 4 }}>
    ⏱ {minutesElapsed(order.opened_at)} min
  </div>
</div>


                <button
                  onClick={() => dispatchOrder(order.live_order_id)}
                  style={dispatchBtn}
                >
                  DISPATCH
                </button>
              </div>

              <hr />

              {/* ITEMS */}
              <div>
                {order.items.map((i, idx) => (
                  <div key={idx} style={itemRow}>
                    <span>
                      {i.item_name}
                      {i.size_name && (
                        <span style={{ color: "#666" }}>
                          {" "}({i.size_name})
                        </span>
                      )}
                    </span>

                    <span style={{ fontWeight: "bold" }}>
                      × {i.qty}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ===== STYLES ===== */

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
  gap: 16
};

const cardStyle = {
  border: "1px solid #ccc",
  borderRadius: 10,
  padding: 14,
  background: "#fff",
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
};

const itemRow = {
  display: "flex",
  justifyContent: "space-between",
  padding: "6px 0",
  borderBottom: "1px dashed #eee",
  fontSize: 14
};

const dispatchBtn = {
  padding: "6px 14px",
  background: "#0a7cff",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer"
};
